import { Model } from '@/features/model';
import { Modal } from '@/shared/ui/modal/modal';
import { Rotate3DIcon } from 'lucide-react';
import { Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Action } from '../action/action';
import styles from './model-action.module.css';

export const ModelAction = () => {
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const { t } = useTranslation();

	return (
		<>
			<Action
				tooltip={t('actions.3d')}
				onClick={() => setIsOpen(true)}
				icon={{
					component: Rotate3DIcon,
				}}
			/>
			<Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
				<div className={styles.modal}>
					<Suspense>
						<Model />
					</Suspense>
				</div>
			</Modal>
		</>
	);
};
